<template>
  <v-autocomplete
    v-model="workOrderSelection"
    :items="workOrderList"
    :menuprops="{ maxHeight: '400' }"
    :label="$t('laboratory.labels.workOrder')"
    chips
    clearable
    itemValue="name"
    :searchInput.sync="search"
  >
    <template
      slot="selection"
      slot-scope="{ item }"
    >
      <div>
        <span>{{ item.name }}</span>
        <span class="time">{{ item.createdAt }}</span>
      </div>
    </template>
    <template
      slot="item"
      slot-scope="{ item }"
    >
      <div>
        <span>{{ item.name }}</span>
        <span class="time">{{ item.createdAt }}</span>
      </div>
    </template>
  </v-autocomplete>
</template>
<script>

export default {
    name: 'AnanlysisAddToExistingWorkOrderForm',
    props: {
        siteId: {
            type: String,
            default: '',
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return (
            {
                search: '',
                workOrderSelection: '',
                workOrderList: [],
                fullWoList: [],
            }
        );
    },
    watch: {
        workOrderSelection() {
            this.search = '';
            this.$emit('sendData', this.getSelectedFullSelection());
        },
    },
    created() {
        this.getWorkdOrdersList();
    },
    methods: {
        async getWorkdOrdersList() {
            if (this.siteId) {
                const { data } = await this.$rq.getSiteWorkOrdersList({ siteId: this.siteId, sampleType: `${this.type }` });
                this.fullWoList = data.labWorkOrders;
                this.workOrderList = this.fullWoList.map((wo, key) => ({
                    name: wo.woNumber,
                    createdAt: wo.createdAt,
                    key,
                }));
            }
        },
        getSelectedFullSelection() {
            let selection = null;
            const matchFound = this.fullWoList.find(wo => wo.woNumber === this.workOrderSelection);
            if (matchFound) {
                selection = matchFound.id;
            }
            return selection;
        },
    },
};
</script>
<style lang="scss" scoped>
.time {
    margin-left: 50px;
    color: #707070;
    font-style: italic;
}
</style>
